export const fetchPolicyData = async () => {
  const conn_name = "crmwidgetconnection";
  const apiUrl =
    "https://www.zohoapis.com/creator/v2.1/data/sst1source/source-erp/report/Quality_Policy_Report/4599841000005403003";

  const req_data = {
    method: "GET",
    url: apiUrl,
    param_type: 1,
  };

  try {
    const response = await ZOHO.CRM.CONNECTION.invoke(conn_name, req_data);

    if (!response || !response.details || !response.details.statusMessage) {
      console.error("❌ Invalid response structure:", response);
      return [];
    }

    let records = response.details.statusMessage.data;

    // ✅ Handle case where records is not an array
    if (!Array.isArray(records)) {
      console.warn("⚠️ Fetched data is not an array, wrapping it in an array.");
      records = [records];
    }

    console.log("✅ Parsed Quality Policy Records:", records);

    return records.map((item) => ({
      id: item.ID,
      policyText: item.Multi_Line || "No policy text available",
      ...item,
    }));
  } catch (error) {
    console.error("❌ Error fetching Quality Policy data:", error);
    return [];
  }
};
